import type { StaticLayerPayload } from "@config";
import { EmbeddedLibrary } from "@library-elements/embedded";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: EmbeddedLibrary,
};

export const Embedded = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
